import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Initiate Google OAuth flow
 */
export const initiateGoogleLogin = async () => {
  try {
    // Get Google auth URL from backend
    const response = await axios.get(`${API}/auth/google/login`);
    // Redirect to Google
    window.location.href = response.data.url;
  } catch (error) {
    console.error('Failed to initiate Google login:', error);
    throw error;
  }
};

/**
 * Process Google OAuth callback
 * @returns {Promise<{token: string, user: object} | null>}
 */
export const processGoogleCallback = async () => {
  // Check for authorization code in URL
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');

  if (!code) {
    return null;
  }

  try {
    // Send code to backend
    const response = await axios.post(
      `${API}/auth/google/callback`,
      { code },
      { withCredentials: true }
    );

    // Clean URL
    window.history.replaceState(null, '', window.location.pathname);

    return response.data;
  } catch (error) {
    console.error('Google auth error:', error);
    throw error;
  }
};

/**
 * Check if user is authenticated via cookie
 */
export const checkExistingSession = () => {
  // Check if session_token cookie exists
  const cookies = document.cookie.split(';');
  return cookies.some(cookie => cookie.trim().startsWith('session_token='));
};

/**
 * Logout user
 */
export const logout = async () => {
  try {
    await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  } catch (error) {
    console.error('Logout error:', error);
  }
};
